import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  colors: {
    primary: "#007AFF",
    text: "#333333",
    background: "#FFFFFF",
    // Add other colors as needed
  },
};
